import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=1b0f3331&scoped=true"
import script from "./Error.vue?vue&type=script&lang=ts"
export * from "./Error.vue?vue&type=script&lang=ts"
import style0 from "./Error.vue?vue&type=style&index=0&id=1b0f3331&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0f3331",
  null
  
)

export default component.exports